module.exports = __webpack_public_path__ + "static/media/card-blog16.23d6a0a2.jpg";